import { ButtonPosition } from '@/common/manager/position/button-position';
import { getArrayTableCurrentRowByField2 } from '@/common/util/util';
export const config = {
    value: 'arrayTableCopy',
    position: [ButtonPosition.arrayTableOperate],
    action: (config) => {
        const { field } = config || {};
        // 获取当前行数据
        const currentRow = getArrayTableCurrentRowByField2(field);
        // 获取当前行index
        const currentRowIndex = field?.path?.segments?.slice(-2, -1)?.[0];
        // 当前行下插入新行
        field.parent.insert(currentRowIndex, { ...currentRow });
    },
};
